import React from 'react';
import PropTypes from 'prop-types';

import styles from './Rating.module.postcss';

function getYelpRatingImage(rating) {
  const fullStars = Math.floor(rating);
  const halfStar = rating - Math.floor(rating) >= 0.5;

  return `${fullStars}${halfStar ? '_half' : ''}.png`;
}

function Rating({ rating, ratingCount, yelp }) {
  const fullStars = Math.floor(rating);
  const halfStar = rating - Math.floor(rating) >= 0.5;

  if (yelp && rating) {
    const yelpRatingImage = getYelpRatingImage(rating);

    return (
      <div>
        <a href={yelp} className={styles.Rating} target="_blank">
          <img
            src={`/static/images/yelp_stars/${yelpRatingImage}`}
            alt={`Yelp ${fullStars}${halfStar ? '.5 ' : ''} Stars`}
            width='130'
            height='24'
          />
          <img
            src="/static/images/yelp_logo.svg"
            alt="Yelp Logo"
            width='62'
            height='24'
          />
        </a>
        { ratingCount &&
          <span className={styles.Rating_explanation}>
            Based on {ratingCount} reviews
          </span>
        }
      </div>
    );
  }

  return null;
}

Rating.propTypes = {
  rating: PropTypes.node,
  ratingCount: PropTypes.node,
  yelp: PropTypes.string,
};

export default Rating;

